import { toggleValues } from 'platform/site-wide/feature-toggles/selectors';

import {
  GET_STARTED_PATH,
  GET_STARTED_URL,
  START_PATH,
  START_URL,
  WIZARD_STATUS,
} from '../constants/entryConstants';

// Accessing sessionStorage raises a SecurityError when storage is blocked
// (third-party iframes, strict site-data settings, some MDM policies). Both
// callers read this during render, where an uncaught throw would unmount the
// app, so degrade to "screener not run" instead.
export const getWizardStatus = () => {
  try {
    return sessionStorage.getItem(WIZARD_STATUS);
  } catch {
    return null;
  }
};

export const showSubTaskStartFlow = state => {
  const toggles = toggleValues(state);

  if (typeof toggles.disability526NewStartExperienceEnabled === 'boolean') {
    return toggles.disability526NewStartExperienceEnabled;
  }

  if (
    typeof toggles.disability_526_new_start_experience_enabled === 'boolean'
  ) {
    return toggles.disability_526_new_start_experience_enabled;
  }

  if (typeof toggles.show526Wizard === 'boolean') {
    return toggles.show526Wizard === false;
  }

  if (typeof toggles.show526_wizard === 'boolean') {
    return toggles.show526_wizard === false;
  }

  return false;
};

// The URL rename ships with the sub-task redesign, so turning the toggle off
// also restores /start for the legacy wizard.
export const getStartPath = state =>
  showSubTaskStartFlow(state) ? GET_STARTED_PATH : START_PATH;

export const getStartUrl = state =>
  showSubTaskStartFlow(state) ? GET_STARTED_URL : START_URL;
